import styled from "styled-components";

const Portal = styled.div`
  display: none;
`;

export default Portal;
